module.exports = __webpack_public_path__ + "img/icon-recommend-active.f6141dd.webp";